import { gql } from "@apollo/client";

export const CORE_PROJECT_FIELDS = gql`
  fragment CoreProjectFields on Project {
    id
    name
    number
    location
    emergencyContact {
      name
      phoneNumber
    }
  }
`;
